import { render, staticRenderFns } from "./lineup.vue?vue&type=template&id=0c8e8f3e&scoped=true"
import script from "./lineup.vue?vue&type=script&lang=js"
export * from "./lineup.vue?vue&type=script&lang=js"
import style0 from "./lineup.vue?vue&type=style&index=0&id=0c8e8f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e8f3e",
  null
  
)

export default component.exports